import InputMask from 'react-input-mask';

const Input = ({id , label,name,mask,formik,disabled = false,type = 'text',placeholder = '',required = false,readOnly = false,isLtr = false}) => {
    return (
        <div className="form-group">
            <label>{label}</label>
            <InputMask mask={mask}  id={id} type={type} name={name} className={`form-control ${isLtr ? 'ltr-input' : ''} ${formik.errors[name] || id ? ' is-invalid' : ''}`} required={required} readOnly={readOnly} placeholder={placeholder} {...formik.getFieldProps(name)} disabled={disabled} />
            {formik.errors[name] && formik.touched[name] && (
                <small className="text-danger">{formik.errors[name]}</small>
            )}
        </div>
    );
}

export default Input;